import IconButton from "@mui/material/IconButton";
import React, { useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { OndemandVideo } from "@mui/icons-material";
import { DataGrid, GridVisibilityOffIcon } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";

export default function WebinarGridTable({ appliedStatus, webinarAnalytics, appliedUniversities, payload }) {
  const navigate = useNavigate();

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });

  const { page, pageSize } = paginationModel;

  function convertToDateObject(dateString) {
    const [year, month, day] = dateString.split('-');
    return new Date(`${year}-${month}-${day}`);
  }

  const [rows, setrows] = useState([]);

  useEffect(() => {
    console.warn(webinarAnalytics); // This will log the raw webinar analytics data
    console.warn("appliedUniversities", appliedUniversities); // This will log the raw webinar analytics data

    let webinarAnalyticsTemp = appliedUniversities ? webinarAnalytics : []
    console.warn("webinarAnalyticsTemp", webinarAnalyticsTemp, webinarAnalytics)
    
    
    
    // const filteredRows = (webinarAnalytics || [])
    const filteredRows = (webinarAnalyticsTemp || [])
      .filter((item) => {
        // If no status filters are applied, include all items
        if (appliedStatus.size === 0) {
          return true;
        }

        // Check for 'Successful' status
        const isSuccessful =
          appliedStatus.has('Successful') &&
          item.webinar_status === 1 &&
          item.session_quality_score > 0;

        // Check for 'Unsuccessful' status (0 or 2)
        const isUnsuccessful =
          appliedStatus.has('Unsuccessful') &&
          (item.webinar_status === 0 ||
            item.webinar_status === 2 ||
            item.session_quality_score === 0);

        // Return true if the item matches any of the selected statuses
        return isSuccessful || isUnsuccessful;
      })
      .map((item, index) => ({
        id: item.id,
        sno: page * pageSize + index + 1, // Continuous serial number
        duration: item.webinar_duration,
        webinarTitle: item.webinar_name,
        sessionqualityscore: item.session_quality_score,
        notes: item.webinar_notes,
        Redflagidentified: item.is_flagged? "Yes": "No",
        createdAt: convertToDateObject(item.created_at),
        date: convertToDateObject(item.webinar_date),
        sessionType: item.webinar_type,
        view: item.webinar_status, // Keep the raw status here, or convert if needed for display
        videourl: item.webinar_recording_url,
      }));
      if(payload) setrows(filteredRows);
  }, [webinarAnalytics, appliedStatus, page, pageSize]);

  const handleViewClick = (params) => {
    const row = params.row;
    console.warn('webinar cliicket', row);
    if (row.view !== 1) return;
    if (row.sessionqualityscore === 0) return;

    if (row && row.id) {
      let route = '/individualteacher/webinarAnalytics';

      navigate(route, {
        state: {
          ...row,
        },
      });
    } else {
      console.error('Row or ID is undefined');
    }
  };

  const columns = [
    {
      field: 'sno',
      headerName: 'S.No',
      flex: 0.5,
      align: 'center',
      headerAlign: 'left',
      sortable: false,
    },
    {
      field: 'webinarTitle',
      headerName: 'Webinar Title',
      flex: 2,
      align: 'left',
      headerAlign: 'left',
    },
    {
      field: 'date',
      headerName: 'Date',
      type: 'date',
      flex: 1.2,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        const date = params.value;
        return date
          ? date.toLocaleDateString('en-US', {
              month: 'short',
              day: '2-digit',
              year: 'numeric',
            })
          : '';
      },
    },
    {
      field: 'duration',
      headerName: 'Duration (HH:MM:SS)',
      width: 180,
      align: 'center',
      headerAlign: 'left',
      valueFormatter: (params) => {
        const value = params;

        const totalSeconds = Number(value);
        if (isNaN(totalSeconds)) return '00:00:00';

        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        const pad = (n) => String(n).padStart(2, '0');
        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
      },
    },
    {
      field: 'sessionType',
      headerName: 'Session Type',
      flex: 1.2,
      align: 'left',
      headerAlign: 'left',
    },
    {
      field: 'sessionqualityscore',
      headerName: 'Session Quality Score',
      flex: 1.2,
      align: 'center',
      headerAlign: 'left',
    },
    {
      field: 'notes',
      headerName: 'Notes',
      flex: 2,
      align: 'left',
      headerAlign: 'left',
    },
    {
      field: 'Redflagidentified',
      headerName: 'Red Flag Identified',
      flex: 1.3,
      align: 'left',
      headerAlign: 'left',
      renderCell: (params) => {
        return params.value;
       }
    },
    {
      field: 'createdAt',
      headerName: 'Uploaded On',
      type: 'date',
      flex: 1.2,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        const date = params.value;
        return date
          ? date.toLocaleDateString('en-US', {
              month: 'short',
              day: '2-digit',
              year: 'numeric',
            })
          : '';
      },
    },

    {
      field: 'view',
      headerName: 'Action',
      flex: 1,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        const isAvailable =
          params.value === 1 && params.row.sessionqualityscore > 0;
        const videoUrl = params.row.videourl;

        const handlePlayClick = (event) => {
          event.stopPropagation(); // Prevent row click
          if (videoUrl) {
            window.open(videoUrl, '_blank'); // Open video in new tab
          }
        };

        const handleViewIconClick = (event) => {
          event.stopPropagation(); // Prevent row click
          if (!isAvailable) return;
          if (params.row.view === 1) {
            // Your existing navigation logic here:
            const route = '/individualteacher/webinarAnalytics';
            navigate(route, { state: { ...params.row } });
          }
        };

        if (!isAvailable) {
          return (
            <>
              <Tooltip title="Analytics not available" placement="top">
                <span>
                  <IconButton
                    size="small"
                    disabled
                    style={{
                      outline: 'none',
                      boxShadow: 'none',
                      border: 'none',
                    }}
                  >
                    <GridVisibilityOffIcon />
                  </IconButton>
                </span>
              </Tooltip>

              <Tooltip title="Watch Recording" placement="top">
                <IconButton
                  onClick={handlePlayClick}
                  size="small"
                  style={{
                    outline: 'none',
                    boxShadow: 'none',
                    border: 'none',
                    marginLeft: 8,
                  }}
                >
                  <OndemandVideo />
                </IconButton>
              </Tooltip>
            </>
          );
        }

        return (
          <>
            <Tooltip title="View Analytics" placement="top">
              <IconButton
                onClick={handleViewIconClick}
                size="small"
                style={{
                  outline: 'none',
                  boxShadow: 'none',
                  border: 'none',
                }}
              >
                <VisibilityIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Watch Recording" placement="top">
              <IconButton
                onClick={handlePlayClick}
                size="small"
                style={{
                  outline: 'none',
                  boxShadow: 'none',
                  border: 'none',
                  marginLeft: 8,
                }}
              >
                <OndemandVideo />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  return (
    <div style={{ width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        paginationModel={paginationModel}
        onPaginationModelChange={(newModel) => setPaginationModel(newModel)}
        autoHeight
        localeText={{ noRowsLabel: 'No Webinar Analytics available' }}
        pageSizeOptions={[20, 50, 100]}
        onRowClick={handleViewClick}
        sx={{
          'fontFamily': 'Nunito Sans, sans-serif',
          'fontSize': '14px',
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#ebebeb',
            color: '#000',
            fontWeight: 'bold',
            fontSize: '14px',
            padding: '6px',
          },
          '& .MuiDataGrid-cell': {
            padding: '6px',
            fontSize: '14px',
          },
          '& .MuiDataGrid-row:hover': {
            cursor: 'pointer',
            backgroundColor: '#f5f5f5',
          },
        }}
      />
    </div>
  );
}
